
import { BaseResponseType } from "./message"
import { UploadFile, UploadProps } from "antd"


export interface MenuItem {
  id:any
  key:string
  children:MenuItem[]
  title:string
  iconUrl?:string
  pagePath: string[]
}

export type formItemType= 'input' | 'select' | 'radio' | 'checkbox' | 'switch' | 'datePicker' | 'timePicker' 

export interface FormItem {
  label:string | React.ReactNode
  name:string
  rules?:any[]
  type?:string
  required?:boolean
  disabled?:boolean
  maxLength?:number
  itemType:formItemType
  placeholder?:string
  options?:any[]
  style?:React.CSSProperties
  defaultValue?:any
  disabledDate?:any
  // inputProps?:any
  // selectProps?:any
  // radioProps?:any
  // checkboxProps?:any
  // switchProps?:any
  // datePickerProps?:any
  // timePickerProps?:any
}


export interface UploadFileSize {
  singleSizeLimit?:number
  totalSizeLimit?:number
  totalSize?:number
}

export interface UseUpload extends UploadFileSize {
  uploadFileAction:(file:FormData,config?:any) => Promise<BaseResponseType<any>>
  fileRegex?:RegExp
  initFile?:UploadFileType[]
}

export interface UploadFileType extends UploadFile {
  fileId?:string
}

export enum UploadFileStatus {
  ERROR='error',
  DONE ='done',
  UPLOADING='uploading',
  REMOVED ='removed'
}

type BaseListItem =Omit<MenuItem,'pagePath' | 'key' | 'children'>

export interface ResourceListItem<T=any> extends BaseListItem {
  children?:T[]
}